import { render, staticRenderFns } from "./dialog-sales-order.vue?vue&type=template&id=0c8dfd3c"
import script from "./dialog-sales-order.vue?vue&type=script&lang=js"
export * from "./dialog-sales-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports